import { style } from '@vanilla-extract/css';

export const accordionElement = style({
  display: 'flex',
  flexDirection: 'column',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  gap: 'var(--gap)',
  padding: 'var(--padding)',
  borderRadius: 'var(--border-radius)',
  boxShadow: 'var(--box-shadow)',
  background: 'var(--background-color)',
  borderWidth: 'var(--border-width)',
  borderColor: 'var(--border-color)',
  borderStyle: 'var(--border-style)',
  selectors: {
    '&[role="button"]': {
      cursor: 'pointer',
    },
  },
});

export const accordionTitle = style({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'space-between',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  padding: 'var(--padding)',

  '@media': {
    'only screen and (--mobile)': {
      padding: 'var(--mobile-padding, var(--padding))',
    },
  },
});

export const accordionSvg = style({
  transition: 'transform 0.2s ease',
  color: 'var(--arrow-color)',
  selectors: {
    '[data-state=open] &': {
      transform: 'rotate(180deg)',
    },
  },
});

// Uses CSS Grid 0fr → 1fr for height animation — no JS measurement needed
export const accordionContent = style({
  display: 'grid',
  gridTemplateRows: '0fr',
  transition: 'grid-template-rows 0.2s ease',
  width: 'var(--width)',
  maxWidth: 'var(--max-width)',
  selectors: {
    '[data-state=open] &': {
      gridTemplateRows: '1fr',
    },
  },
});

export const accordionContentInner = style({
  overflow: 'hidden',
  minHeight: 0,
  padding: 'var(--padding)',
  transition: 'padding 0.2s ease',
  selectors: {
    '[data-state=closed] &': {
      paddingTop: '0px',
      paddingBottom: '0px',
    },
  },

  '@media': {
    'only screen and (--mobile)': {
      padding: 'var(--mobile-padding, var(--padding))',
    },
  },
});
